import { systemSettingsApi } from "api/master";

export default class SystemSettingsService {
	update = (...args) => systemSettingsApi.update(...args);
	bulkUpdate = (...args) => systemSettingsApi.bulkUpdate(...args);
	delete = (...args) => systemSettingsApi.remove(...args);
	deleteStorePicHandler = (...args) =>
		systemSettingsApi.deleteStorePic(...args);
}
